module.exports = __webpack_public_path__ + "img/pack.7519ca19.svg";